import { render, staticRenderFns } from "./IconLogout.vue?vue&type=template&id=3fe4effc&"
import script from "./IconLogout.vue?vue&type=script&lang=js&"
export * from "./IconLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports